document.addEventListener('DOMContentLoaded', function () {
    var hyswiper = new Swiper('.home-youtube-bg', {
        loop: true,
        speed: 3000,
        freeMode: true,
        autoplay: {
            delay: 0,
            stopOnLastSlide: false,
            disableOnInteraction: true,
        },
        slidesPerView: 12,
        spaceBetween: 1,
        centeredSlides: true,
        watchSlidesProgress: true,
        mousewheels: true,

        breakpoints: {
            320: {
                slidesPerView: 2,
            },

            450: {
                slidesPerView: 3,
            },

            700: {
                slidesPerView: 5,
            },

            900: {
                slidesPerView: 6,
            },

            1150: {
                slidesPerView: 7,
            },

            1300: {
                slidesPerView: 8,
            },

            1500: {
                slidesPerView: 9,
            },
            1700: {
                slidesPerView: 12,
            },
        },
    });
    hyswiper.el.onmouseover = function () {
        hyswiper.autoplay.stop();
    };

    hyswiper.el.onmouseout = function () {
        hyswiper.autoplay.start();
    };
});